<template>
  <div id="contenedor-main-licitacion-junta-aclaraciones">
    <listado />
  </div>
</template>

<script>
import Listado from './listado/Main.vue';

export default {
  name: 'MainLicitacionJuntaAclaraciones',
  components: {
    Listado,
  },

  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
</style>
